import { KnowledgebaseFile } from "@/types/knowledgebase"

/**
 * Filter files to get only SharePoint files
 */
export function getSharepointFiles(files: KnowledgebaseFile[]): KnowledgebaseFile[] {
  return files.filter((f) => f.source === "SHAREPOINT")
}

/**
 * Get count of SharePoint files
 */
export function getSharepointFilesCount(files: KnowledgebaseFile[]): number {
  return getSharepointFiles(files).length
}
